/** Team 0 = no team / free-for-all.  1 = Red.  2 = Blue. */
export const TEAM_COLORS: Record<number, string> = {
  0: "#fb923c",  // no team — amber
  1: "#ef4444",  // red
  2: "#22d3ee",  // blue
};

export const TEAM_NAMES: Record<number, string> = {
  0: "",
  1: "RED",
  2: "BLUE",
};

export function teamColor(teamId: number): string {
  return TEAM_COLORS[teamId] ?? TEAM_COLORS[0];
}

/**
 * Assign a team for a new player.
 * - If `preferred` (1 or 2) does not put that team more than 1 ahead, honour it.
 * - Otherwise assign to the smaller team.
 * - Ties (equal counts) go to team 1.
 */
export function assignTeam(
  team1Count: number,
  team2Count: number,
  preferred?: number,
): number {
  if (preferred === 1 || preferred === 2) {
    const otherCount = preferred === 1 ? team2Count : team1Count;
    const ownCount   = preferred === 1 ? team1Count : team2Count;
    if (ownCount <= otherCount) return preferred; // honours preference without imbalance
  }
  return team1Count <= team2Count ? 1 : 2;
}

/**
 * True when two players are on the same non-zero team.
 * Team 0 (FFA / unassigned) is never considered allied with anyone,
 * including other team-0 players.
 */
export function sameTeam(teamA: number, teamB: number): boolean {
  return teamA !== 0 && teamB !== 0 && teamA === teamB;
}
